(function () {
  const root = window.Shopify?.routes?.root || '/';
  const sourceId = 'pk-cart-drawer';
  const pendingForms = new WeakSet();
  let latestCartRequest = 0;
  let drawerRequest = 0;

  async function showCart() {
    const request = ++drawerRequest;
    const styles = document.getElementById('pkCartStyles');
    if (styles && !styles.sheet && styles.dataset?.state !== 'failed') {
      await new Promise(resolve => {
        styles.addEventListener('load', resolve, { once: true });
        styles.addEventListener('error', resolve, { once: true });
      });
    }
    if (request !== drawerRequest) return;
    if (styles?.dataset?.state === 'failed') {
      window.location.assign(root + 'cart');
      return;
    }
    const drawer = document.getElementById('pkCartDrawer');
    drawer?.removeAttribute('inert');
    drawer?.setAttribute('aria-hidden', 'false');
    drawer?.classList.add('is-open');
    document.getElementById('pkCartOverlay')?.classList.add('is-open');
  }

  async function openCart() {
    const [, cart] = await Promise.all([showCart(), fetchCart()]);
    return cart;
  }

  function closeCart() {
    ++drawerRequest;
    const drawer = document.getElementById('pkCartDrawer');
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('inert', '');
    drawer?.setAttribute('aria-hidden', 'true');
    document.getElementById('pkCartOverlay')?.classList.remove('is-open');
  }

  async function requestCart(path, options = {}) {
    const response = await fetch(root + path, {
      ...options,
      cache: 'no-store',
      headers: { Accept: 'application/json', ...options.headers }
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
    return data;
  }

  function publishCart(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId, data: { source: sourceId, itemCount: cart.item_count } }
    }));
  }

  function formatMoney(cents) {
    return `Rs. ${(cents / 100).toFixed(2)}`;
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  window.PKCart = { open: openCart, close: closeCart, refresh: fetchCart };

  async function fetchCart({ throwOnError = false } = {}) {
    const request = ++latestCartRequest;
    try {
      const cart = await requestCart('cart.js');
      if (request !== latestCartRequest) return null;
      renderCart(cart);
      return cart;
    } catch (err) {
      console.error('[PKCart] Failed to fetch cart:', err);
      if (throwOnError) throw err;
      return null;
    }
  }

  function renderCart(cart) {
    const cartBody = document.getElementById('pkCartBody');
    const subtotalEl = document.getElementById('pkCartSubtotal');
    const countEl = document.getElementById('pkCartCount');
    updateCartBadge(cart.item_count);
    renderShipping(cart);
    if (!cartBody) return;

    cartBody.innerHTML = '';

    if (!cart.items || !cart.items.length) {
      cartBody.innerHTML = `
        <div class="pk-drawer__empty">
          <p class="pk-display">Your bag is empty</p>
          <p>Engineered products await.</p>
          <a href="/" class="pk-btn pk-btn--outline pk-btn--sm">Shop Now</a>
        </div>
      `;
      if (subtotalEl) subtotalEl.textContent = '—';
      if (countEl) countEl.style.display = 'none';
      updateCartBadge(0);
      return;
    }

    cart.items.forEach(function(item) {
      try {
        // Variant image first, fall back to product image
        var imageUrl = '';
        if (item.featured_image && item.featured_image.url) {
          imageUrl = item.featured_image.url;
        } else if (item.image) {
          imageUrl = item.image;
        }

        // Build options — split variant_title as reliable fallback
        var options = [];
        if (item.variant_title && item.variant_title !== 'Default Title') {
          var parts = item.variant_title.split(' / ');
          options = parts.map(function(v) { return v.trim(); }).filter(Boolean);
        }

        var optionsHtml = '';
        if (options.length) {
          optionsHtml = '<div class="pk-cartrow__options">';
          options.forEach(function(val) {
            optionsHtml += '<div class="pk-cartrow__option"><span class="pk-cartrow__option-value">' + esc(val) + '</span></div>';
          });
          optionsHtml += '</div>';
        }

        var wasPrice = '';
        if (item.original_price !== item.final_price) {
          wasPrice = '<span class="pk-cartrow__price--was">' + formatMoney(item.original_price * item.quantity) + '</span>';
        }

        var imgHtml = imageUrl
          ? '<img src="' + imageUrl + '" alt="' + esc(item.product_title) + '" loading="lazy">'
          : esc((item.product_title || '').substring(0, 2).toUpperCase());

        var html = '<div class="pk-cartrow" data-key="' + esc(item.key) + '">'
          + '<div class="pk-cartrow__img">' + imgHtml + '</div>'
          + '<div>'
          + '<div class="pk-cartrow__name">' + esc(item.product_title) + '</div>'
          + optionsHtml
          + '<div class="pk-cartrow__qty">'
          + '<button data-action="decrease" aria-label="Decrease quantity">−</button>'
          + '<span>' + item.quantity + '</span>'
          + '<button data-action="increase" aria-label="Increase quantity">+</button>'
          + '</div>'
          + '<button class="pk-cartrow__remove" aria-label="Remove item">Remove</button>'
          + '</div>'
          + '<div>'
          + wasPrice
          + '<span class="pk-cartrow__price">' + formatMoney(item.final_line_price) + '</span>'
          + '</div>'
          + '</div>';

        cartBody.insertAdjacentHTML('beforeend', html);
      } catch (err) {
        console.error('[PKCart] Error rendering item:', item, err);
      }
    });

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    }
    updateCartBadge(cart.item_count);
  }

  // Says what checkout will charge for shipping before the shopper gets there. Mirrors the
  // store's General profile: a flat rate per started kg up to max-kg, free over free-over.
  function renderShipping(cart) {
    const shipEl = document.getElementById('pkCartShipping');
    if (!shipEl) return;
    const freeOver = Number(shipEl.dataset.freeOver);
    const perKg = Number(shipEl.dataset.perKg);
    const maxKg = Number(shipEl.dataset.maxKg);
    const kg = Math.max(1, Math.ceil((cart.total_weight || 0) / 1000));
    let text = '';
    if (cart.item_count && cart.total_price > freeOver) {
      text = 'Free shipping on this order';
    } else if (cart.item_count && kg <= maxKg) {
      // Free shipping needs strictly more than freeOver, so an exact match is still 1 paisa short.
      const gap = Math.max(freeOver - cart.total_price, 1);
      text = `Shipping ${formatMoney(kg * perKg)} · add ${formatMoney(gap)} more for free shipping`;
    }
    shipEl.textContent = text;
    shipEl.hidden = !text;
    const noteEl = document.getElementById('pkCartNote');
    if (noteEl) noteEl.textContent = text ? 'Taxes calculated at checkout' : 'Shipping & taxes calculated at checkout';
  }

  function updateCartBadge(count) {
    document.querySelectorAll('.pk-cart-dot').forEach((badge) => {
      badge.textContent = count > 9 ? '9+' : count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  async function updateQuantity(key, quantity) {
    try {
      const cart = await requestCart('cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      ++latestCartRequest;
      renderCart(cart);
      publishCart(cart);
    } catch (err) {
      console.error('[PKCart] Failed to change quantity:', err);
    }
  }

  /* Event delegation */
  document.addEventListener('click', (e) => {
    if (e.target.closest('.pk-cart-toggle') || e.target.closest('.pk-cartbtn')) {
      if (window.PKCart) window.PKCart.open();
      return;
    }

    if (e.target.closest('.pk-cart-close') || e.target === document.getElementById('pkCartOverlay')) {
      closeCart();
      return;
    }

    const row = e.target.closest('.pk-cartrow');
    if (!row) return;
    const key = row.dataset.key;

    if (e.target.closest('[data-action]')) {
      const action = e.target.closest('[data-action]').dataset.action;
      const qtyEl = row.querySelector('.pk-cartrow__qty span');
      const currentQty = parseInt(qtyEl.textContent, 10);
      if (action === 'increase') updateQuantity(key, currentQty + 1);
      if (action === 'decrease' && currentQty > 1) updateQuantity(key, currentQty - 1);
      return;
    }

    if (e.target.closest('.pk-cartrow__remove')) {
      updateQuantity(key, 0);
    }
  });

  /* Add-to-cart intercept */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action$="/cart/add"], form[action$="/cart/add/"]')) return;
    if (e.defaultPrevented) return;
    if (pendingForms.has(form)) {
      e.preventDefault();
      return;
    }
    if (e.submitter && e.submitter.matches('[data-pk-buy-now]')) return;
    e.preventDefault();

    const button = e.submitter || form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    const variantId = form.querySelector('[name="id"]')?.value;
    const originalText = button.textContent;
    const iconButton = button.classList.contains('pk-pdp__cart');
    const body = new FormData(form);
    form.querySelector('[data-pk-cart-error]')?.remove();
    pendingForms.add(form);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (!iconButton) button.textContent = 'ADDING…';

    try {
      await requestCart('cart/add.js', { method: 'POST', body });
      const cart = await fetchCart({ throwOnError: true });
      if (cart) publishCart(cart);
      await showCart();
    } catch (err) {
      const error = document.createElement('p');
      error.setAttribute('data-pk-cart-error', '');
      error.setAttribute('role', 'alert');
      error.textContent = err.message || 'Unable to update your cart. Please try again.';
      form.appendChild(error);
      console.error('[PKCart] Failed to add item:', err);
    } finally {
      pendingForms.delete(form);
      button.removeAttribute('aria-busy');
      if (!iconButton) button.textContent = originalText;
      if (form.querySelector('[name="id"]')?.value === variantId) button.disabled = false;
    }
  });

  document.addEventListener('cart:update', (event) => {
    if (event.detail?.sourceId === sourceId || event.detail?.data?.didError) return;
    fetchCart();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fetchCart(), { once: true });
  } else {
    fetchCart();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) fetchCart();
  });
})();
